export default __webpack_public_path__ + "static/media/GoldPlated8mmBangles.2c8d0d41.jpg";